export const moveToFocusedInboxText = "Txc";
export const moveToOtherInboxText = "Uxc";
export const alwaysMoveToFocusedInboxText = "Vxc";
export const alwaysMoveToOtherInboxText = "Wxc";
export const moveToFolderMoveAllFrom = "Xxc";
export const moveToOtherDisabledDueToOverride = "Yxc";
export default {moveToFocusedInboxText,moveToOtherInboxText,alwaysMoveToFocusedInboxText,alwaysMoveToOtherInboxText,moveToFolderMoveAllFrom,moveToOtherDisabledDueToOverride};